import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import EducationalStages from './components/EducationalStages';
import Pricing from './components/Pricing';
import Testimonials from './components/Testimonials';
import Faq from './components/Faq';
import Footer from './components/Footer';
import JoinUs from './components/JoinUs';
import FloatingWhatsApp from './components/FloatingWhatsApp';

const HomePage = () => {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <Services />
        <EducationalStages />
        <Testimonials />
        <Faq />
      </main>
      <Footer />
      <FloatingWhatsApp />
    </>
  );
};

const PricingPage = () => {
  return (
    <>
      <Header />
      <div className="min-h-screen bg-gray-50 pt-20">
        <Pricing />
      </div>
      <Footer />
      <FloatingWhatsApp />
    </>
  );
};


const JoinUsPage = () => {
  return (
    <>
      <Header />
      <JoinUs />
      <Footer />
      <FloatingWhatsApp />
    </>
  );
};

function App() {
  return (
    <Router>
      <div className="font-sans antialiased">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/join-us" element={<JoinUsPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;